import React, { useEffect } from 'react';
import { useModal } from 'projects/components/modal/BetaModalProvider';
import { useHasAICoding } from 'hooks/feature-flags/queries';

const ProjectChatBetaModal = () => {
  const { openModal, closeModal } = useModal();
  const { hasAICoding: featureFlagAICoding, isLoading } = useHasAICoding();

  useEffect(() => {
    // Don't do anything while loading
    if (isLoading) {
      return;
    }

    if (featureFlagAICoding === false) {
      openModal();
    } else if (featureFlagAICoding === true) {
      closeModal();
    }
  }, [featureFlagAICoding, isLoading, openModal, closeModal]);

  return <></>
};

export default ProjectChatBetaModal;
